export const isLoginFromWebsite = (): string => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('websiteLogin');
};
